import React from "react";
import { InputRangeRow } from "./index";
// Used by Heli KV2008B and Heli KV2019B machines

export default function MinStrokeRow() {
   return (
      <InputRangeRow
         titleProp={"Min Stroke"}
         descriptionProp={"mm"}
         sizeProp={6}
         colSizeProp={6}
         typeProp={"text"}
         minProp={25.0}
         maxProp={370.0}
         propertyNameProp={"minStroke"}
         errorDialogueProp={"25.0-370.0 only"}
         floatProp={true}
      />
   );
}
